import type { ActionButtonProps } from '../commandActions/types'
import { ChangeTemplateSourceNestedCommand } from './ChangeTemplateSourceNestedCommand'
import { EmployerAgreementCommandNester } from './EmployerAgreementCommandNester'

export const ChangeTemplateSourceCommand = (props: ActionButtonProps) => (
  <EmployerAgreementCommandNester
    NestedCommand={ChangeTemplateSourceNestedCommand}
    {...props}
  />
)
